// reducer.js
import {
  SET_VALUE_Pdp,
  SET_TYPE_Pdp,
  SET_CURRENT_PAGE_Pdp,
  SET_ORDER_Pdp,
  SET_SORT_FIELD_Pdp,
  SET_ACTIF_Pdp,
} from "./actionsTypes";

const initialState = {
  value: "",
  type: "",
  actif: "",
  currentPage: 1,
  order: "asc",
  sortField: "nom",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_Pdp:
      return {
        ...state,
        value: action.payload,
      };
    case SET_TYPE_Pdp:
      return {
        ...state,
        type: action.payload,
      };

    case SET_CURRENT_PAGE_Pdp:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_Pdp:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_Pdp:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_ACTIF_Pdp:
      return {
        ...state,
        actif: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
